// extracted by mini-css-extract-plugin
export var statItem = "_gi-1";
export var statsRow = "_gi-0";